<template>
    <div class="animated fadeIn" id="orcamento-analistas">
        <div class="card card-default">
            <div class="card-header">
                <div class="card-header">
                    <i class="fa fa-calendar"></i> Orçamento dos Analistas
                </div>
            </div>
            <div class="card-body">
                <!-- Primeira linha: Profissional | Ano | Sistema -->
                <div class="input-group mb-3 align-items-center" style="gap: 10px;">
                    <!-- Profissional -->
                    <span class="input-group-text d-flex align-items-center justify-content-center" id="profissional"
                        style="width: 100px; height: 40px;">
                        Profissional
                    </span>
                    <b-dropdown :text="dropdownLabel" class="align-middle custom-dropdown input-custom"
                        style="margin-left: 0px; margin-bottom: 0px; width: 260px;" toggle-class="custom-dropdown-input"
                        no-close-on-click no-auto-close="outside">
                        <!-- Botões de ação -->
                        <b-dropdown-item-button @click="selecionarTodosProfissionais">
                            <i class="fa fa-check-square mr-2"></i> Selecionar todos
                        </b-dropdown-item-button>
                        <b-dropdown-item-button @click="limparProfissionaisSelecionados">
                            <i class="fa fa-times mr-2"></i> Limpar seleção
                        </b-dropdown-item-button>
                        <b-dropdown-divider></b-dropdown-divider>
                        <!-- Lista de profissionais com checkboxes -->
                        <div v-for="(prof, idx) in profissionais"
                            :key="`${checkboxRenderKey}-prof-${prof && prof.id ? prof.id : idx}`" class="px-3 py-1">
                            <b-form-checkbox v-model="selectedProfissionais" :value="prof">
                                {{ prof.nome }}
                            </b-form-checkbox>
                        </div>
                    </b-dropdown>
                    <!-- Ano -->
                    <span class="input-group-text d-flex align-items-center justify-content-center"
                        style="width: 100px; height: 40px;">
                        Ano
                    </span>
                    <YearPicker v-model="milestone" class="input-custom" style="width: 260px; margin-right: 8px;" />
                    <!-- Sistema -->
                    <span class="input-group-text d-flex align-items-center justify-content-center"
                        style="width: 100px; height: 40px;">
                        Sistema
                    </span>
                    <b-dropdown :text="dropdownSistemaLabel" class="align-middle custom-dropdown input-custom"
                        style="margin-left: 0px; margin-bottom: 0px; width: 260px;" toggle-class="custom-dropdown-input"
                        no-close-on-click no-auto-close="outside">
                        <!-- Botões de ação -->
                        <b-dropdown-item-button @click="selecionarTodosSistemas">
                            <i class="fa fa-check-square mr-2"></i> Selecionar todos
                        </b-dropdown-item-button>
                        <b-dropdown-item-button @click="limparSistemasSelecionados">
                            <i class="fa fa-times mr-2"></i> Limpar seleção
                        </b-dropdown-item-button>
                        <b-dropdown-divider></b-dropdown-divider>
                        <!-- Lista de sistemas com checkboxes -->
                        <div
                            style="max-height: 220px; overflow-y: auto; min-width: 260px; width: 260px; max-width: 260px;">
                            <div v-for="(sistema, idx) in sistemasDisponiveis"
                                :key="`${checkboxRenderKey}-sistema-${sistema}`" class="px-3 py-1">
                                <b-form-checkbox v-model="selectedSistemas" :value="sistema">
                                    {{ sistema }}
                                </b-form-checkbox>
                            </div>
                        </div>
                    </b-dropdown>
                </div>
                <!-- Segunda linha: Data Envio para Qualificação -->
                <div class="input-group mb-3 align-items-center" style="gap: 10px;">
                    <span class="input-group-text d-flex align-items-center justify-content-center"
                        style="width: 210px; height: 40px;">
                        Data Envio para Qualificação
                    </span>
                    <date-picker v-model="dataEnvioInicio" format="DD/MM/YYYY" lang="pt-br"
                        input-class="form-control datepicker-custom input-custom" :placeholder="'Início'"
                        style="width: 140px; margin-right: 8px;" />
                    <date-picker v-model="dataEnvioFim" format="DD/MM/YYYY" lang="pt-br"
                        input-class="form-control datepicker-custom input-custom" :placeholder="'Fim'"
                        style="width: 140px; margin-right: 8px;" />
                </div>
                <!-- Terceira linha: Pesquisar -->
                <div class="d-flex justify-content-end">
                    <button class="btn btn-primary" style="height: 40px;" @click="pesquisar">
                        <i class="icon-magnifier"></i> Pesquisar
                    </button>
                </div>
                <!-- Tabela de Horas por Milestone -->
                <div v-if="registrosHorasMilestone.length > 0" class="mt-4">
                    <table class="table table-bordered table-striped table-sm text-center align-middle">
                        <thead>
                            <tr>
                                <th>Analista</th>
                                <th v-for="milestone in milestonesUnicas" :key="milestone">{{ milestone }}</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(analista, idx) in tabelaOrcamento">
                                <tr :key="`analista-${idx}`">
                                    <td>
                                        {{ analista.nome_analista }}
                                    </td>
                                    <td v-for="milestone in milestonesUnicas" :key="`cell-${milestone}`">
                                        <span style="cursor:pointer; color:#007bff;"
                                            @click="toggleExpandMilestone(analista.nome_analista, milestone)">
                                            {{ analista.milestones[milestone] || '0.00' }}
                                        </span>
                                    </td>
                                    <td>{{ analista.total }}</td>
                                </tr>
                                <!-- Exibe as issues em uma linha única, sem divisão de colunas -->
                                <template v-for="milestone in milestonesUnicas">
                                    <template
                                        v-if="issuesPorMilestone[`${analista.nome_analista}-${milestone}`] && issuesPorMilestone[`${analista.nome_analista}-${milestone}`].length > 0">
                                        <tr :key="`issues-row-${analista.nome_analista}-${milestone}`">
                                            <td colspan="100%">
                                                <table class="table table-bordered table-sm" style="margin-bottom:0;">
                                                    <thead>
                                                        <tr>
                                                            <th>Sistema</th>
                                                            <th>Título</th>
                                                            <th>Envio</th>
                                                            <th>Fim</th>
                                                            <th>Dias</th>
                                                            <th>Orçado</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(issue, iidx) in issuesPorMilestone[`${analista.nome_analista}-${milestone}`]"
                                                            :key="`issue-data-${iidx}`">
                                                            <td>{{ issue.sistema }}</td>
                                                            <td
                                                                style="max-width: 320px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; position: sticky; left: 0; background: #fff; z-index: 2;">
                                                                <a :href="issue.link" target="_blank"
                                                                    style="color:#007bff; display: inline-block; max-width: 400px; vertical-align: middle; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                                                                    :title="issue.title">
                                                                    {{ issue.title.length > 60 ? issue.title.slice(0,
                                                                        57) + '...' : issue.title }}
                                                                </a>
                                                            </td>
                                                            <td>{{ issue.data_envio_qualificacao }}</td>
                                                            <td>{{ issue.data_fim_qualificacao }}</td>
                                                            <td>{{ issue.dias_em_qualificacao }}</td>
                                                            <td>{{ issue.orcado }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import ptBr from "vue2-datepicker";
import YearPicker from "@/components/YearPicker.vue"; // ajuste o path se necessário

export default {
    name: 'OrcamentoAnalistasIndex',
    components: {
        DatePicker,
        YearPicker,
    },
    data() {
        return {
            profissionais: [],
            selectedProfissionais: [],
            checkboxRenderKey: 0,
            milestone: null,
            milestoneFormatado: "",
            milestoneLang: ptBr,
            sistemasDisponiveis: [],
            selectedSistemas: [],
            dataEnvioInicio: null,
            dataEnvioFim: null,
            registrosHorasMilestone: [],
            milestonesUnicas: [],
            tabelaOrcamento: [],
            showModalSistemas: false,
            sistemasAnalista: [],
            sistemaSelecionadoModal: "",
            issuesSistema: [],
            registroModal: null,
            analistasExpandido: [],
            issuesPorMilestone: {}, // Novo estado para issues por analista-milestone
        };
    },
    watch: {
        milestone(val) {
            // Atualiza milestoneFormatado sempre que o ano for selecionado
            this.milestoneFormatado = val ? String(val) : "";
        }
    },
    computed: {
        dropdownLabel() {
            const total = this.selectedProfissionais.length;
            return total === 0
                ? "Selecionar profissionais"
                : `${total} profissional${total > 1 ? "is" : ""} selecionado${total > 1 ? "s" : ""}`;
        },
        dropdownSistemaLabel() {
            const total = this.selectedSistemas.length;
            return total === 0
                ? "Selecionar sistemas"
                : `${total} sistema${total > 1 ? "s" : ""} selecionado${total > 1 ? "s" : ""}`;
        },
    },
    async mounted() {
        await this.getProfissionais();
        await this.getSistemasDisponiveis();
        this.gerarMesesAnoVigente();
    },
    methods: {
        async getProfissionais() {
            try {
                const response = await this.$http.get("/orcamento-analistas/analistas");
                this.profissionais = Array.isArray(response.data) ? response.data : [];
            } catch (error) {
                console.error('Erro ao buscar profissionais:', error);
                this.profissionais = [];
            }
        },
        async getSistemasDisponiveis() {
            try {
                const response = await this.$http.get("/orcamento-analistas/sistemas");
                // Espera um array de objetos { sistema: "Nome" }
                this.sistemasDisponiveis = Array.isArray(response.data)
                    ? response.data.map(s => s.sistema)
                    : [];
            } catch (error) {
                this.sistemasDisponiveis = [];
            }
        },
        selecionarTodosProfissionais() {
            this.selectedProfissionais = this.profissionais.slice();
            this.checkboxRenderKey++;
        },
        limparProfissionaisSelecionados() {
            this.selectedProfissionais = [];
            this.checkboxRenderKey++;
        },
        selecionarTodosSistemas() {
            this.selectedSistemas = this.sistemasDisponiveis.slice();
            this.checkboxRenderKey++;
        },
        limparSistemasSelecionados() {
            this.selectedSistemas = [];
            this.checkboxRenderKey++;
        },
        onChangeMilestone(val) {
            if (val) {
                // val é um objeto Date, pega apenas o ano
                const ano = val.getFullYear();
                this.milestoneFormatado = `${ano}`;
            } else {
                this.milestoneFormatado = "";
            }
        },
        pesquisar() {
            const profissionaisLimpos = this.selectedProfissionais.map(prof => ({
                nome: prof.nome,
                usuario_gitlab_id: prof.usuario_gitlab_id
            }));
            console.log('Profissionais selecionados:', profissionaisLimpos);
            console.log('Milestone:', this.milestoneFormatado);
            console.log('Data Envio para Qualificação - Início:', this.dataEnvioInicio);
            console.log('Data Envio para Qualificação - Fim:', this.dataEnvioFim);
            console.log('Sistemas selecionados:', this.selectedSistemas);
            // Limpa todas as issues expandidas antes de pesquisar
            this.issuesPorMilestone = {};
            this.sistemasExpandido = {};
            this.analistasExpandido = [];
            this.buscaHorasPorMilestone();
        },

        async buscaHorasPorMilestone() {
            try {
                // Usa o valor do sistema diretamente do filtro (não precisa de label)
                let sistemaSelecionado = undefined;
                if (this.selectedSistemas.length > 0) {
                    sistemaSelecionado = this.selectedSistemas[0];
                }
                // Envia todos os profissionais selecionados como array de nomes
                let profissionaisSelecionados = [];
                if (this.selectedProfissionais.length > 0) {
                    profissionaisSelecionados = this.selectedProfissionais.map(p => p.nome);
                }
                // Adiciona os filtros de início e fim
                const inicio = this.dataEnvioInicio
                    ? this.formatDateToISO(this.dataEnvioInicio)
                    : "";
                const fim = this.dataEnvioFim
                    ? this.formatDateToISO(this.dataEnvioFim)
                    : "";

                const response = await this.$http.get("/orcamento-analistas/horas-milestone", {
                    params: {
                        milestone: this.milestoneFormatado,
                        sistema: sistemaSelecionado,
                        profissional: profissionaisSelecionados, // agora é array
                        inicio,
                        fim
                    }
                });
                this.registrosHorasMilestone = Array.isArray(response.data.registros) ? response.data.registros : [];
                // Gera as colunas de acordo com os milestones retornados
                const milestonesSet = new Set(this.registrosHorasMilestone.map(r => r.milestone));
                this.milestonesUnicas = Array.from(milestonesSet).sort((a, b) => {
                    // Ordena por ano e mês
                    const [ma, ya] = a.split('-');
                    const [mb, yb] = b.split('-');
                    if (ya !== yb) return ya - yb;
                    return ma - mb;
                });
                // Extrai nomes únicos dos analistas presentes nos registros
                const nomesAnalistas = [
                    ...new Set(this.registrosHorasMilestone.map(r => r.nome_analista))
                ];
                // Monta tabela apenas para os analistas presentes nos registros
                this.tabelaOrcamento = nomesAnalistas.map(nomeAnalista => {
                    const milestones = {};
                    let total = 0;
                    this.milestonesUnicas.forEach(milestone => {
                        // Busca registro para esse analista e milestone
                        const registro = this.registrosHorasMilestone.find(r =>
                            r.nome_analista === nomeAnalista && r.milestone === milestone
                        );
                        let horas = registro
                            ? (registro.total_orcado !== undefined && registro.total_orcado !== null
                                ? registro.total_orcado
                                : '0.00')
                            : '0.00';
                        if (typeof horas !== 'string') {
                            horas = String(horas !== undefined && horas !== null ? horas : '0.00');
                        }
                        milestones[milestone] = horas;
                        total += parseFloat(horas.replace(',', '.')) || 0;
                    });
                    return {
                        nome_analista: nomeAnalista,
                        milestones,
                        total: total.toFixed(2)
                    };
                });
            } catch (error) {
                console.error('Erro ao buscar horas por milestone:', error);
                this.registrosHorasMilestone = [];
                this.tabelaOrcamento = [];
                this.milestonesUnicas = [];
            }
        },
        async toggleExpandAnalista(analista, milestone) {
            const key = `${analista}-${milestone}`;
            const idx = this.analistasExpandido.indexOf(key);
            if (idx === -1) {
                this.analistasExpandido.push(key);
                await this.buscarSistemasAnalista(analista, milestone);
            } else {
                this.analistasExpandido.splice(idx, 1);
            }
        },
        async toggleExpandSistema(analista, milestone, sistema) {
            const key = `${analista}-${milestone}`;
            // Se já está expandido para esse sistema, fecha
            if (
                this.sistemasExpandido[key] &&
                this.sistemasExpandido[key].sistema === sistema
            ) {
                this.$set(this.sistemasExpandido, key, []);
                return;
            }
            // Busca issues do sistema (corrigido para GET)
            try {
                const inicio = this.dataEnvioInicio ? this.formatDateToISO(this.dataEnvioInicio) : "";
                const fim = this.dataEnvioFim ? this.formatDateToISO(this.dataEnvioFim) : "";
                const response = await this.$http.get(
                    "/orcamento-analistas/issues",
                    {
                        params: { analista, milestone, sistema, inicio, fim },
                        headers: { 'Content-Type': 'application/json' }
                    }
                );
                this.$set(this.sistemasExpandido, key, response.data.issues || []);
            } catch (error) {
                this.$set(this.sistemasExpandido, key, []);
            }
        },
        async buscarSistemasAnalista(analista, milestone) {
            try {
                const response = await this.$http.get("/orcamento-analistas/sistemas", {
                    params: {
                        analista,
                        milestone
                    }
                });
                this.$set(this.sistemasPorAnalista, `${analista}-${milestone}`, response.data.sistemas || []);
            } catch (error) {
                this.$set(this.sistemasPorAnalista, `${analista}-${milestone}`, []);
            }
        },
        async dropdownSystems(registro) {
            try {
                const response = await this.$http.get("/orcamento-analistas/sistemas", {
                    params: {
                        analista: registro.nome_analista,
                        milestone: registro.milestone
                    }
                });
                this.sistemasAnalista = Array.isArray(response.data.sistemas) ? response.data.sistemas : [];
                this.sistemaSelecionadoModal = "";
                this.issuesSistema = [];
                this.registroModal = registro;
                this.showModalSistemas = true;
            } catch (error) {
                console.error('Erro ao buscar sistemas do analista:', error);
                this.sistemasAnalista = [];
                this.issuesSistema = [];
                this.showModalSistemas = true;
            }
        },
        async buscarIssuesSistema() {
            if (!this.sistemaSelecionadoModal || !this.registroModal) return;
            try {
                const response = await this.$http.get("/orcamento-analistas/issues", {
                    params: {
                        analista: this.registroModal.nome_analista,
                        milestone: this.registroModal.milestone,
                        sistema: this.sistemaSelecionadoModal
                    }
                });
                this.issuesSistema = Array.isArray(response.data.issues) ? response.data.issues : [];
            } catch (error) {
                console.error('Erro ao buscar issues do sistema:', error);
                this.issuesSistema = [];
            }
        },
        gerarMesesAnoVigente() {
            const ano = new Date().getFullYear();
            this.milestonesUnicas = Array.from({ length: 12 }, (_, i) => {
                const mes = String(i + 1).padStart(2, '0');
                return `${mes}-${ano}`;
            });
        },
        async toggleExpandMilestone(analista, milestone) {
            const key = `${analista}-${milestone}`;
            const idx = this.analistasExpandido.indexOf(key);
            if (idx === -1) {
                this.analistasExpandido.push(key);
                await this.buscarIssuesPorMilestone(analista, milestone);
            } else {
                this.analistasExpandido.splice(idx, 1);
                // Retrai/remover as issues da visualização
                this.$delete(this.issuesPorMilestone, key);
            }
        },
        async buscarIssuesPorMilestone(analista, milestone) {
            try {
                const inicio = this.dataEnvioInicio ? this.formatDateToISO(this.dataEnvioInicio) : "";
                const fim = this.dataEnvioFim ? this.formatDateToISO(this.dataEnvioFim) : "";
                const response = await this.$http.get(
                    "/orcamento-analistas/issues",
                    {
                        params: { analista, milestone, inicio, fim },
                        headers: { 'Content-Type': 'application/json' }
                    }
                );
                this.$set(this.issuesPorMilestone, `${analista}-${milestone}`, response.data.issues || []);
            } catch (error) {
                this.$set(this.issuesPorMilestone, `${analista}-${milestone}`, []);
            }
        },
        formatDateToISO(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },

    }
}
</script>

<style>
.teste {
    padding: 16px;
    background: #f0f0f0;
    border-radius: 4px;
    font-weight: bold;
}

.input-group-text {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    font-size: 14px;
    height: 40px;
}

/* Dropdown customizado para Profissional e Sistema */
.custom-dropdown .dropdown-toggle,
.custom-dropdown .dropdown-toggle:hover,
.custom-dropdown .dropdown-toggle:focus,
.custom-dropdown .dropdown-toggle:active,
.custom-dropdown.show .dropdown-toggle,
.custom-dropdown .dropdown-toggle.btn-primary,
.custom-dropdown.show .dropdown-toggle.btn-primary {
    background-color: transparent !important;
    border: 1px solid #dde2e7 !important;
    color: #6c757d !important;
    box-shadow: none !important;
    width: 260px !important;
    min-width: 180px !important;
    max-width: 260px !important;
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    line-height: 38px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

/* Ajuste opcional: remover outline de foco do Bootstrap */
.custom-dropdown .dropdown-toggle:focus {
    outline: none !important;
}

/* Dropdown menu */
.custom-dropdown .dropdown-menu {
    border: 1px solid #6c757d;
    border-radius: 4px;
    min-width: 260px !important;
    width: 260px !important;
    max-width: 260px !important;
    padding: 0;
    /* Remove fixed height here, use scroll on inner div */
}

/* Dropdown item */
.custom-dropdown .dropdown-item {
    min-width: 260px;
    width: 260px;
    max-width: 260px;
}

.datepicker-custom {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
    font-size: 14px;
}

.sistema-select {
    height: 40px !important;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid #dde2e7;
    background: #fff;
    color: #333;
    padding: 0 8px;
    min-width: 280px;
    width: 280px;
    max-width: 280px;
    text-align: center;
}

/* Estilo para o placeholder do select de sistemas */
.sistema-select option.sistema-placeholder {
    color: #6c757d !important;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    background: #fff;
}

.sistema-placeholder {
    color: #6c757d !important;
}

.sistema-select-modal {
    height: 40px !important;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid #dde2e7;
    background: #fff;
    color: #333;
    padding: 0 8px;
}

/* --- INÍCIO: Layout replicado do dropdown de alocacao-horas --- */
.custom-dropdown .dropdown-toggle {
    background-color: transparent !important;
    border: 1px solid #6c757d !important;
    color: #6c757d !important;
    border-radius: 4px;
}

.custom-dropdown .dropdown-toggle:hover,
.custom-dropdown .dropdown-toggle:focus,
.custom-dropdown .dropdown-toggle:active {
    background-color: transparent !important;
    border-color: #6c757d !important;
    color: #6c757d !important;
    box-shadow: none !important;
}

/* Customização do botão quando está aberto */
.custom-dropdown.show .dropdown-toggle {
    background-color: transparent !important;
    border-color: #6c757d !important;
    color: #6c757d !important;
}

/* Customização do menu dropdown */
.custom-dropdown .dropdown-menu {
    border: 1px solid #6c757d;
    border-radius: 4px;
}

/* --- FIM: Layout replicado do dropdown de alocacao-horas --- */

/* Remover estilos antigos conflitantes do dropdown antigo */
.custom-dropdown .dropdown-toggle,
.custom-dropdown .dropdown-toggle.btn-primary,
.custom-dropdown.show .dropdown-toggle.btn-primary {
    /* removido: background-color, border, color, box-shadow, width, min-width, max-width, height, min-height, max-height, line-height, padding-top, padding-bottom */
}

.custom-dropdown .dropdown-menu {
    /* removido: min-width, width, max-width, padding */
}

/* Esconde anos fora de 2023-2025 no painel de anos do vue2-datepicker */
.mx-panel-year .cell {
    display: none;
}

.mx-panel-year .cell:nth-child(4),
.mx-panel-year .cell:nth-child(5),
.mx-panel-year .cell:nth-child(6) {
    display: inline-block;
}





.mx-panel-year .mx-btn-current-year::after {
    content: "2023 ~ 2025";
    color: #333;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    text-align: center;
    width: 100%;
    pointer-events: none;
}

/* Estilo padronizado para todos os inputs customizados */
.input-custom,
.input-custom .dropdown-toggle,
.input-custom .form-control,
.input-custom input,
.input-custom .datepicker-custom {
    background: #fff !important;
    border: 1px solid #dde2e7 !important;
    color: #333 !important;
    border-radius: 4px !important;
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    font-size: 14px !important;
    box-shadow: none !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.input-custom input::placeholder,
.input-custom .form-control::placeholder {
    color: #6c757d !important;
    opacity: 1;
}

.input-custom .dropdown-toggle {
    width: 260px !important;
    min-width: 180px !important;
    max-width: 260px !important;
    line-height: 38px !important;
    padding-left: 12px !important;
    padding-right: 12px !important;
}

/* Remove highlight azul do bootstrap ao focar */
.input-custom .dropdown-toggle:focus,
.input-custom .form-control:focus,
.input-custom input:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: #a0a0a0 !important;
}

/* Ajuste para YearPicker se necessário */
.input-custom .mx-input,
.input-custom .mx-input:focus {
    background: #fff !important;
    border: 1px solid #dde2e7 !important;
    color: #333 !important;
    border-radius: 4px !important;
    height: 40px !important;
    font-size: 14px !important;
    box-shadow: none !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
</style>